<template>
  <div>
    <div class="tips">{{ tipsText }}</div>
    <div class="scroll-wrap" v-if="data_list.length">
      <ul>
        <li
          class="welfare_block"
          v-for="(type_data, idx1) in data_list"
          :key="'type_' + idx1"
          @click="click_img(type_data)"
        >
          <div class="info">
            <div class="left">
              <p class="title">{{ type_data.award_name }}</p>
              <p  v-if="type_data.vip_id_limit === 'mpp_svip'" :class="['level', outOfCondition(type_data) && !type_data.received ? 'cantRecv' : '']">
                <span
                  >SVIP V{{ type_data.growth_level
                  }}{{
                    type_data.max_growth_level === type_data.growth_level
                      ? ''
                      : `-V${type_data.max_growth_level}`
                  }}</span
                >会员专享
              </p>
              <p v-else :class="['level', outOfCondition(type_data) && !type_data.received ? 'cantRecv' : '']">
                <span
                  >V{{ type_data.growth_level
                  }}{{
                    type_data.max_growth_level === type_data.growth_level
                      ? ''
                      : `-V${type_data.max_growth_level}`
                  }}</span
                >会员专享
              </p>
            </div>
            <div class="right">
              <img :src="type_data.head_img" alt="" />
            </div>
          </div>
          <div
            :class="['btn', outOfCondition(type_data) && !type_data.received ? 'cantRecv' : '']"
            @click.stop="handleBtn(type_data)"
          >
            {{ handleText(type_data) }}
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import click_handler from '../../../tools/mgtv/click';
import {jumpToMoreBenefit, outOfLevel, outOfVipIdLimit } from './benefitApi';
import {GET_GIFT} from '../../../constant/eventbus'
// 福利社改版 https://wiki.imgo.tv/pages/viewpage.action?pageId=48204157

export default {
  name: 'NzmRightscroll',
  components: {},
  props: {
    info: {
      type: Object,
      default: () => {
        return {};
      }
    },
    data_list: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data: function() {
    return {};
  },
  created() {},
  methods: {
    outOfLevel,
    outOfVipIdLimit,
    outOfCondition(awardInfo) {
      return outOfLevel(awardInfo)/*  || outOfVipIdLimit(awardInfo) */;
    },
    handleText(awardInfo) {
      if (!this.user.ticket) {
        return '登录领取';
      }
      if(awardInfo.received){
        return '已领取';
      }
      if (!outOfLevel(awardInfo)) {
          return '立即领取';
      } else if (this.user.level < awardInfo.growth_level) {
        return '升级权益';
      } else if (this.user.level > awardInfo.max_growth_level) {
        return '不符合条件';
      }
    },
    click_img: function(item) {
      jumpToMoreBenefit(item, this.info.act_name);
    },
    handleBtn(item) {
      if (item.out_stock === 1) {
        return;
      }
      const need_vip_level = item.received === 1 ? 0 : item.growth_level; //如果已领取，则不检查等级，否则检查等级
      click_handler(
        `领取福利-${item.award_name}`,
        () => {
          if (this.outOfCondition(item) && !item.received) {
            window.$act_alert_dialog.show({
              title: `<div style="text-align: center;font-size:.36rem;color:#666;margin-bottom:.2rem">抱歉，领取失败～</div>
                    <div style="text-align: center;font-size:.28rem;color:#666;margin-bottom:.2rem">需满足会员身份未过期及符合对应等级才可领取哦~</div>`,
              button: '我知道了'
            });
            return;
          }
          window.$bus.$emit(GET_GIFT, {awardInfo:item, act_name:this.info.act_name});
        },
        {
          need_login: true,
          need_act: true,
          need_vip_level: need_vip_level,
          need_mpp_svip: item.vip_id_limit === 'mpp_svip',
          max_vip_level: item.max_growth_level
        }
      );
    }
  },
  mounted() {},

  computed: {
    user() {
      return window.$bus.user;
    },
    tipsText() {
      if (this.user.ticket) {
        if (this.user.level >= 1) {
          let pre = this.user.is_mpp_svip === 1 ? 'SVIP' : 'V';
          return `您当前为${pre}${this.user.level}会员，可领取以下优惠，右滑可查看更多惊喜哦`;
        } else {
          return `您当前为V0会员，请升级后领取以下优惠，右滑查看更多惊喜`;
        }
      } else {
        return `请您登录后领取以下优惠，右滑可查看更多惊喜哦`;
      }
    }
  }
};
</script>

<style lang="stylus" scoped>
@import "../../../share/mixins.styl"
.tips
  height: 0.24rem;
  font-size: 0.24rem;
  font-weight: 400;
  color: #999999;
  line-height: 0.24rem;
  padding-left: 0.3rem;
  margin-top: -0.16rem;
.scroll-wrap
  overflow-x scroll
  overflow-y: hidden
  width: 100%
  padding-left 0.3rem
  &::-webkit-scrollbar
    display none
  ul
    display: flex
    height: 2.34rem
    flex-wrap: nowrap
    align-items: center
    li
      flex-shrink: 0
      height 1.8rem
      margin-right: 0.16rem
      width: 3rem
      box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.1);
      position: relative
      background: url('https://vipcdn.mgtv.com/lego/20211228/lego/6f86ec6067cb11eca0f76c92bf1519bc.png') top center no-repeat;
      background-size: cover
      border-radius: 0.1rem;
      overflow: hidden
      .info
        display: flex
        justify-content: space-between
        padding: 0.12rem
        width: 100%
        box-sizing: border-box
        .left
          max-width: 1.9rem
        .title
          height: 0.4rem;
          font-size: 0.28rem;
          font-weight: 500;
          color: #111111;
          line-height: 0.4rem;
          overflow: hidden;
          text-overflow: ellipsis
          word-break: break-all
          white-space: nowrap
          margin: 0.04rem 0
        .level
          height: 0.34rem;
          font-size: 0.20rem;
          font-weight: 400;
          color: #D9AC63;
          line-height: 0.34rem;
          overflow: hidden;
          text-overflow: ellipsis
          word-break: break-all
          white-space: nowrap
          &.cantRecv
            color: #CCCCCC
        .right
          width: 0.88rem
          height: 0.88rem
          overflow hidden
          border-radius: 50%
          flex-shrink: 0
          img
            width: 100%
            height: 100%
      .btn
        text-align: center
        width: 2.76rem;
        height: 0.44rem;
        background: linear-gradient(90deg, #FFE6B4 0%, #F6C371 100%);
        border-radius: 0.08rem;
        line-height: 0.44rem
        color: #804919;
        font-size: 0.24rem
        position: absolute
        bottom: 0.08rem
        left: 50%
        transform: translateX(-50%)
        &.cantRecv
          background: linear-gradient(90deg, #FFA651 0%, #FF5F00 100%);
          color: #fff;
</style>
